module.exports = __webpack_public_path__ + "img/all-logos.af4cd436.png";